import React, { useEffect } from "react"
import { Modal } from "../../../NewModal"
import { Flex } from "rebass"
import { css } from "@emotion/react"
import { InlineSpan } from "../../../inline-span/InlineSpan"
import { SignUpFormType } from "../../../../models/sign-up-form"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { translationKeys } from "../../../../util/translationKeys"
import { useAuthModals } from "../../../../context/AuthModalsContext"
import { useSignupInfo } from "../../../../services/queries"
import { SignUpForm } from "./SignUpForm"

const modalStyle = css`
  flex-direction: column;
  align-items: space-between;
  gap: 24px;
  width: 100%;
`

type Props = {
  setSignUpData: (data: SignUpFormType) => void
  setSignUpError: (value: string | undefined) => void
  signUpError: string | undefined
  countryCode?: string
}

export const SignUpModal = ({
  setSignUpData,
  signUpError,
  setSignUpError,
  countryCode,
}: Props) => {
  const { t } = useTranslation()

  const { visibleAuthModal, setVisibleAuthModal } = useAuthModals()

  const { data: signupInfo, isLoading: signupInfoLoading } = useSignupInfo()

  useEffect(() => {
    if (visibleAuthModal !== "register") {
      return
    }
    if (window.analytics) {
      window.analytics.track("Create account started")
    }
  }, [visibleAuthModal])

  if (!signupInfo || signupInfoLoading) {
    return null
  }

  return (
    <Modal
      isVisible={visibleAuthModal === "register"}
      onClose={() => setVisibleAuthModal(undefined)}
      title={`${t(translationKeys.comboCreateaccountGetStartedTitle)}`}
      subtitle={`${t(translationKeys.webSignupExistingaccount)}`}
      subtitleSpan={
        <InlineSpan
          onClick={() => {
            setVisibleAuthModal("login")
          }}
        >
          {t(translationKeys.comboWelcomeLogind)}
        </InlineSpan>
      }
    >
      <Flex css={modalStyle}>
        <SignUpForm
          terms={signupInfo.signup_info[0].terms}
          setSignUpData={setSignUpData}
          signUpError={signUpError}
          setSignUpError={setSignUpError}
          countryCode={countryCode}
        />
      </Flex>
    </Modal>
  )
}
